import { render, staticRenderFns } from "./AllInvitation.vue?vue&type=template&id=ae151df6&scoped=true&"
import script from "./AllInvitation.vue?vue&type=script&lang=js&"
export * from "./AllInvitation.vue?vue&type=script&lang=js&"
import style0 from "./AllInvitation.vue?vue&type=style&index=0&id=ae151df6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae151df6",
  null
  
)

export default component.exports